module.exports = __webpack_public_path__ + "img/lunch_forbid.ee36f8f2.jpg";